import { ldb } from "@/lib/localdb";

// Offline login: salted PBKDF2-SHA256 (WebCrypto). Plain passwords are never stored.
const ITERATIONS = 310000;
export const WRONG = "Incorrect username or password";
export const FIRST_LOGIN = "First login on this device needs internet";

const b64 = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf)));
const unb64 = (s) => Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
const norm = (id) => (id || "").trim().toLowerCase();

async function derive(password, salt, iterations) {
  const key = await crypto.subtle.importKey("raw", new TextEncoder().encode(password), "PBKDF2", false, ["deriveBits"]);
  return b64(await crypto.subtle.deriveBits({ name: "PBKDF2", hash: "SHA-256", salt, iterations }, key, 256));
}

export async function rememberLogin(identifier, password, session) {
  const salt = crypto.getRandomValues(new Uint8Array(16));
  const { token, ...clean } = session;
  await ldb.creds.put({
    identifier: norm(identifier), user_id: session.user.id, salt: b64(salt), iterations: ITERATIONS,
    hash: await derive(password, salt, ITERATIONS), session: clean, saved_at: new Date().toISOString(),
  });
}

export async function offlineLogin(identifier, password) {
  const rec = await ldb.creds.get(norm(identifier));
  if (!rec) return { error: FIRST_LOGIN };
  if ((await derive(password, unb64(rec.salt), rec.iterations)) !== rec.hash) return { error: WRONG };
  return { session: rec.session };
}
